var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.382 2.3379L19.243 15.9536C19.8572 17.0174 19.0895 18.3473 17.861 18.3473H2.13898C0.910537 18.3473 0.142761 17.0174 0.756982 15.9536L8.618 2.3379C9.23222 1.27403 10.7678 1.27403 11.382 2.3379Z",
    stroke: "#888888",
    strokeWidth: 1.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07595 4.73781C9.48699 4.02587 10.5146 4.02588 10.9256 4.73781L16.937 15.1498C17.348 15.8617 16.8342 16.7516 16.0121 16.7516H3.98941C3.16734 16.7516 2.65355 15.8617 3.06459 15.1498L9.07595 4.73781Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31506 12.3495L9.01711 7.95728H10.8048L10.5068 12.3495H9.31506ZM9.91094 14.7619C9.64183 14.7619 9.42078 14.6754 9.24778 14.5024C9.07478 14.3294 8.98828 14.1244 8.98828 13.8873C8.98828 13.6438 9.07478 13.442 9.24778 13.2818C9.42078 13.1152 9.64183 13.0319 9.91094 13.0319C10.1865 13.0319 10.4075 13.1152 10.5741 13.2818C10.7471 13.442 10.8336 13.6438 10.8336 13.8873C10.8336 14.1244 10.7471 14.3294 10.5741 14.5024C10.4075 14.6754 10.1865 14.7619 9.91094 14.7619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.51977ca79a2c59ef8a8e6be220980dc7.svg";
export { ForwardRef as ReactComponent };